import React, { FC, useState } from 'react';
import { createUseStyles } from 'src/theming';
import { CardContent, LinearProgress, Tab, Tabs, Toolbar, Typography } from '@material-ui/core';
import Request, { RequestStatus } from 'src/interfaces/api/Request';
import RequestTable from './components/RequestTable';
import { Order } from 'src/interfaces/Table';
import Site from 'src/interfaces/api/Site';
import Contact from 'src/interfaces/api/Contact';
import Card from 'src/components/Card';

const useStyles = createUseStyles({
  root: {
    marginBottom: 25,
  },
  table: {
    minWidth: 650,
  },
});

interface Props {
  onClickRequest: (requestId: string) => void;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  onChangePage: (event: unknown, newPage: number) => void;
  onFilterStatus: (status?: RequestStatus) => void;
  onChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  requests: Request[];
  sites: { [key: string]: Site };
  contacts: Contact[];
  loading?: boolean;
  total: number;
  page: number;
  order: Order;
  error?: string;
  orderBy: string;
  rowsPerPage: number;
}

enum RequestTab {
  ACTIVE = 0,
  CLOSED = 1,
}

const RequestList: FC<Props> = ({
  loading,
  requests,
  sites,
  contacts,
  total,
  page,
  rowsPerPage,
  order,
  orderBy,
  error,
  onClickRequest,
  onChangeRowsPerPage,
  onFilterStatus,
  onChangePage,
  onRequestSort,
}) => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState<RequestTab>(RequestTab.ACTIVE);

  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    setSelectedTab(newValue);

    if (newValue === RequestTab.CLOSED) {
      onFilterStatus(RequestStatus.CLOSED);
    } else {
      onFilterStatus(undefined);
    }
  };

  return (
    <div id='appView' className='div-entity'>
      <Card className={classes.root}>
        <Toolbar>
          <Typography variant='h6' id='tableTitle' component='div'>
            Demandes clients
          </Typography>
        </Toolbar>

        <CardContent>
          <Tabs value={selectedTab} indicatorColor='primary' textColor='primary' onChange={handleChangeTab}>
            <Tab label='Demandes en cours' />
            <Tab label='Demandes closes' />
          </Tabs>

          {error && (
            <div style={{ color: '#f44336' }}>
              Erreur: {error} (Veuillez communiquer le message d'erreur au support informatique)
            </div>
          )}

          <RequestTable
            requests={requests}
            sites={sites}
            contacts={contacts}
            total={total}
            page={page}
            rowsPerPage={rowsPerPage}
            order={order}
            orderBy={orderBy}
            onClickRequest={onClickRequest}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onChangePage={onChangePage}
            onRequestSort={onRequestSort}
          />
        </CardContent>

        {loading && <LinearProgress />}
      </Card>
    </div>
  );
};

export default RequestList;
